"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lattarico": {
    "8d0b2f97": [{
      "hkey": "24671f0f",
      "slug": "cozzo-carbonaro",
      "name": "Cozzo Carbonaro",
      "primary": true,
      "skipSearch": false
    }],
    "carbonaro": [{
      "hkey": "24671f0f",
      "slug": "cozzo-carbonaro",
      "name": "Cozzo Carbonaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lattarico"
    }],
    "cf5f5ad3": [{
      "hkey": "24671f0f",
      "slug": "cozzo-carbonaro",
      "name": "Cozzo Carbonaro",
      "primary": true,
      "skipSearch": false
    }],
    "cozzo": [{
      "hkey": "24671f0f",
      "slug": "cozzo-carbonaro",
      "name": "Cozzo Carbonaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "df1c67bf": [{
      "hkey": "ac980cd9",
      "slug": "lattarico",
      "name": "Lattarico",
      "primary": true,
      "skipSearch": false
    }],
    "palazzello": [{
      "hkey": "ac980cd9",
      "slug": "lattarico",
      "name": "Lattarico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cad26cd": [{
      "hkey": "ac980cd9",
      "slug": "lattarico",
      "name": "Lattarico",
      "primary": true,
      "skipSearch": false
    }],
    "piretto": [{
      "hkey": "ac980cd9",
      "slug": "lattarico",
      "name": "Lattarico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;